import { render, staticRenderFns } from "./securityOfficer.vue?vue&type=template&id=fd678e2a"
import script from "./securityOfficer.vue?vue&type=script&lang=js"
export * from "./securityOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports